import { memo } from 'react';
import { SelectableChip } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

import { START_FROM_BLANK } from '../../context/roleBuilderReducer';

/**
 * Start from: Blank plus a chip per existing role (copies the studios it covers).
 *
 * @param {object} props
 * @param {object[]} props.roles
 * @param {string} props.value `'blank'` or a role id.
 * @param {(roleId: string|null) => void} props.onChange `null` for Blank.
 */
const StartFromChips = ({ roles, value, onChange }) => {
  const { t } = useTranslation('people-access');
  return (
    <div className="flex flex-wrap gap-2">
      <SelectableChip size="m" selected={value === START_FROM_BLANK} onClick={() => onChange(null)}>
        {t('roles.builder.details.blank')}
      </SelectableChip>
      {roles.map((role) => (
        <SelectableChip key={role.id} size="m" selected={value === role.id} onClick={() => onChange(role.id)}>
          {role.name}
        </SelectableChip>
      ))}
    </div>
  );
};

export default memo(StartFromChips);
